<template>
	<div>
		<!--面包屑导航区域-->
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-date"></i> 宝宝签到导出
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="query" ref="query">
				<div class="handle-box">
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<!--搜索与添加-->
								<el-select v-model="query.valueSABSAAI" clearable filterable :placeholder="'请选择所属幼儿园'" class="handle-select mr10"
								 style="width: 15%;" @change="SABSAAIchange">
									<el-option v-for="item in query.optionsSBASAAI" :key="item.SAAMSID" :label="item.SAANAME" :value="item.SAAMSID">
									</el-option>
								</el-select>

							</div>
						</el-col>
						<!-- <el-col :span="2">
							<div class="grid-content bg-purple-light">
								<el-button type="warning" :disabled="!hasPerms(buttonPerms.searchPerms)" class="float" icon="el-icon-search"
								 @click="handleSearch">搜索</el-button>
							</div>
						</el-col> -->
					</el-row>

					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<el-select v-model="query.valueSABSADI" clearable :placeholder="'请选择所在年级'" class="handle-select mr10" @change="SABSADIchange"
								 :disabled="SABSADIdisabled">
									<el-option v-for="item in query.optionsSABSADI" :key="item.SADMSID" :label="item.SADNAME" :value="item.SADMSID">
									</el-option>
								</el-select>
							</div>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<el-select v-model="query.hadSABI" clearable :placeholder="'请选择所在班级'" class="handle-select mr10" @change="SABNAMEchange"
								 :disabled="HADSABIdisabled">
									<el-option v-for="item in query.optionsHADSABI" :key="item.SABMSID" :label="item.SABNAME" :value="item.SABMSID">
									</el-option>
								</el-select>
							</div>
						</el-col>
					</el-row>

					<!-- <el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<el-input v-model="query.childName" clearable :placeholder="'请输入宝宝姓名'" class="handle-input mr10" style="width: 15%;"></el-input>
							</div>
						</el-col>
					</el-row> -->

					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								
								<el-date-picker v-model="query.start" type="date" :picker-options="starttime" value-format="yyyy-MM-dd"
								 format="yyyy-MM-dd" style="width: 14%;margin-right: 0.8%;" :placeholder="'开始时间'" />
								 
								<span style="margin-right: 0.8%;">-</span>
								
								<el-date-picker v-model="query.end" type="date" :picker-options="endTime" value-format="yyyy-MM-dd"
								 format="yyyy-MM-dd" style="width: 14%;" :placeholder="'结束时间'" />
								 
							</div>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<el-button type='primary' :disabled="!hasPerms(buttonPerms.exportPerms)" icon="el-icon-download" @click="handleSearch">导出Excel</el-button>
							</div>
						</el-col>
						<el-col :span="2">
							<div class="grid-content bg-purple-light">
							</div>
						</el-col>
					</el-row>
				</div>
			</el-form>
		</div>
	</div>
</template>
<script>
	import {
		hasPermission
	} from '@/permission/index.js'
	export default {
		name: 'signInList',
		inject: ['reload'], //在子组件中通过inject调用
		data() {
			return {
				//页面按钮权限
				buttonPerms: {
					searchPerms: 'signIn:signInList:search', //搜索权限标识
					exportPerms: 'signIn:signInList:export', //导出权限标识

					disabled: false
				},

				web_suuid: sessionStorage.getItem("ms_web_suuid"),
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户

				// 开始时间
				starttime: {
					disabledDate: time => {
						if (this.query.end) {
							return (
								time.getTime() > new Date(this.query.end).getTime()
							)
						} else {
							// 不能大于当前日期
							return time.getTime() > Date.now()
						}
					}
				},
				// 结束时间
				endTime: {
					disabledDate: time => {
						if (this.query.start) {
							return (
								time.getTime() > Date.now() ||
								time.getTime() < new Date(this.query.start).getTime() - 8.64e6
							)
						} else {
							return time.getTime() > Date.now()
						}
					}
				},
				SABSAAIdisabled: false,
				SABSADIdisabled: true,
				HADSABIdisabled: true,
				query: {
					valueSABSAAI: '', //幼儿园名称
					optionsSBASAAI: '',
					valueSABSADI: '', //年级名称
					optionsSABSADI: [],
					hadSABI: '', //班级ID
					hadSABNAME: '', //班级名
					optionsHADSABI: '',
					childName: '', //宝宝名称
					start: new Date(new Date(new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/1').getTime()),
					end: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
				},
				signInData: [], //出勤数组
				excelTitle: '',
				excelColumns: ''
			};
		},
		created() {
			//获取幼儿园信息
			this.getSAA();
		},
		mounted() {
			this.$bus.$on('change', () => {
				//刷新当前页面
				this.reload()
			})
		},
		methods: {
			hasPerms: function(perms) {
				// 根据权限标识和外部指示状态进行权限判断
				return hasPermission(perms) & !this.buttonPerms.disabled
			},
			//时间格式化
			dateFormat: function(val) {
				var t = new Date(val); //row 表示一行数据, date 表示要格式化的字段名称
				var year = t.getFullYear(),
					month = t.getMonth() + 1,
					day = t.getDate(),
					hour = t.getHours(),
					min = t.getMinutes();
				var newTime = year + '-' +
					(month < 10 ? '0' + month : month) + '-' +
					(day < 10 ? '0' + day : day) + ' ' +
					(hour < 10 ? '0' + hour : hour) + ':' +
					(min < 10 ? '0' + min : min);
				return newTime;
			},
			/**
			 * @description 幼儿园选择事件
			 * 作者:魏强
			 * 作成时间:2020/11/30
			 * @return {void}
			 * */
			SABSAAIchange() {
				if (typeof(this.query.valueSABSAAI) !== 'undefined') {
					this.getSAD(this.query.valueSABSAAI);
					this.SABSADIdisabled = false;
					this.query.valueSABSADI = '';
					this.query.hadSABI = '';
					this.query.hadSABNAME = '';
					this.HADSABIdisabled = true;
				} else {
					this.SABSADIdisabled = true;
				}
			},
			/**
			 * @description 年级选择事件
			 * 作者:魏强
			 * 作成时间:2020/11/30
			 * @return {void}
			 * */
			SABSADIchange() {
				if (typeof(this.query.valueSABSADI) !== 'undefined') {
					this.getSAB(this.query.valueSABSADI);
					this.HADSABIdisabled = false;
					this.query.hadSABI = '';
					this.query.hadSABNAME = '';
				} else {
					this.HADSABIdisabled = true;
				}
			},
			SABNAMEchange() {
				if (typeof(this.query.hadSABI) !== 'undefined') {
					for(var i=0;i<this.query.optionsHADSABI.length;i++){
						if(this.query.hadSABI == this.query.optionsHADSABI[i].SABMSID){
							this.query.hadSABNAME = this.query.optionsHADSABI[i].SABNAME
							//console.log(this.query.hadSABNAME)
						}
					}
				}
			},
			/**
			 * @description 获取幼儿园信息
			 * 作者:魏强
			 * 作成时间:2020/11/27
			 * @return {void}
			 * */
			getSAA() {
				const that = this;
				var postUrl = 'WCF/WEB/svcZAA.svc/Get_SAA_GardenList';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: that.web_sphon, //web侧 登录ID  tihs.web_suuid
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.query.optionsSBASAAI = response.data.KKDT;
						}
					})
					.catch((error) => {
						this.$message({
							message: '请求失败', //请求失败
							type: 'error'
						});
					});
			},
			/**
			 * @description 获取年级信息
			 * 作者:魏强
			 * 作成时间:2020/11/27
			 * @return {void}
			 * */
			getSAD(valueSAAI) {
				const self_agent = this;
				var postUrl = 'WCF/WEB/svcSAD.svc/GET_SAD_GradeLIST';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
							sSAAI: valueSAAI //web侧 登录ID  tihs.web_suuid
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.query.optionsSABSADI = response.data.KKDT;
						} else {
							this.query.optionsSABSADI = '';
							this.query.valueSABSADI = '';
						}
					})
					.catch((error) => {
						this.query.valueSABSADI = '';
						this.$message({
							message: '获取年级信息请求失败', //请求失败
							type: 'error'
						});
					});
			},

			/**
			 * @description 获取班级信息
			 * 作者:魏强
			 * 作成时间:2020/11/27
			 * @return {void}
			 * */
			getSAB(valueSABSADI) {
				const that = this;
				var postUrl = 'WCF/WEB/svcSAB.svc/GET_SAB_GradeLIST';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: that.web_sphon, //web侧 登录ID  tihs.web_suuid
							sSADI: valueSABSADI //年级ID
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.query.optionsHADSABI = response.data.KKDT;
						} else {
							this.query.optionsHADSABI = '';
							this.query.hadSABI = '';
						}
					})
					.catch((error) => {
						this.$message({
							message: '请求失败', //请求失败
							type: 'error'
						});
					});
			},

			/**
			 * @description 触发搜索按钮
			 * 作者:魏强
			 * 作成时间:2020/11/27
			 * @return {void}
			 * */
			handleSearch() {
				
				let sSTARTDATE = this.query.start// + " 00:00:00";
				let sENDDATE = this.query.end// + " 23:59:59";
				
				//console.log(this.dateFormat(sSTARTDATE)) //开始时间
				//console.log(this.dateFormat(sENDDATE)) //结束时间
				
				//console.log(this.query.valueSABSAAI)
				//console.log(this.query.valueSABSADI)
				//console.log(this.query.hadSABI)

				if (this.query.valueSABSAAI.length == 0) {
					this.$alert('请选择幼儿园', '提示', {
						confirmButtonText: '确定',
						callback: action => {}
					});
					return false;
				}

				if (this.query.valueSABSADI.length == 0) {
					this.$alert('请选择年级', '提示', {
						confirmButtonText: '确定',
						callback: action => {}
					});
					return false;
				}

				if (this.query.hadSABI.length == 0) {
					this.$alert('请选择班级', '提示', {
						confirmButtonText: '确定',
						callback: action => {}
					});
					return false;
				}

				var time_s = new Date(this.dateFormat(this.query.start).replace(/-/g, '/')).getTime();
				var time_e = new Date(this.dateFormat(this.query.end).replace(/-/g, '/')).getTime();
				var nTime = time_e - time_s;
				var day = Math.floor(nTime / 86400000) + 1;

				if (day > 31) {
					this.$alert('请选的日期范围不能超过31天', '提示', {
						confirmButtonText: '确定',
						callback: action => {}
					});
					return false;
				}
				
				if (sSTARTDATE === null && sENDDATE !== null) {
					this.$alert('请选择登入时间', '提示', {
						confirmButtonText: '确定',
						callback: action => {}
					});
					return false;
				} else if (sSTARTDATE !== null && sENDDATE === null) {
					this.$alert('请选择登出时间', '提示', {
						confirmButtonText: '确定',
						callback: action => {}
					});
					return false;
				} else if (sSTARTDATE === null && sENDDATE === null) {
					this.$alert('请选择登入时间和登出时间', '提示', {
						confirmButtonText: '确定',
						callback: action => {}
					});
					return false;
				}

				this.getSignData();
			},
			/**
			 * @description 获取出勤数据
			 * 作者:魏强
			 * 作成时间:2020/11/27
			 * @return {void}
			 * */
			getSignData() {
				
				const that = this;
				var postUrl = 'WCF/WEB/svcZAD.svc/Get_SIGNIN_DATA';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: that.web_sphon, //web侧 登录ID  tihs.web_suuid
							sSAAID: that.query.valueSABSAAI, //幼儿ID
							sSADID: that.query.valueSABSADI, //年级ID
							sSABID: that.query.hadSABI, //班级ID
							sHABNM: that.query.childName.trim(), //宝宝姓名
							sSTDT: this.dateFormat(that.query.start), //开始时间
							sENDT: this.dateFormat(that.query.end) //结束时间
						})
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT0;
						let resKKDT = response.data;
						if (resCount > 0) {
							//渲染数据 List
							this.signInData = resKKDT.KKDT0; //数据数组
							this.excelTitle = resKKDT.KKDT1[0].excelTitle
							this.excelColumns = resKKDT.KKDT1[0].excelColumns

							// console.log(this.signInData)
							// console.log(this.excelTitle)
							// console.log(this.excelColumns)

							this.tableToExcel();

						} else {
							this.signInData = []; //数据数组
							this.excelTitle = []
							this.excelColumns = []

							this.$alert('没有满足条件的考勤数据', '提示', {
								confirmButtonText: '确定',
								callback: action => {}
							});

						}
					})
					.catch((error) => {
						this.$message({
							message: '请求失败', //请求失败
							type: 'error'
						});
					});
			},
			/**
			 * @description 导出Excel
			 * 作者:魏强
			 * 作成时间:2020/11/27
			 * @return {void}
			 * */
			tableToExcel() {
				this.$confirm('此操作将导出excel文件, 是否继续?', '提示', {
					confirmButtonText: '确定', //确定
					cancelButtonText: '取消', //取消
					type: 'warning'
				}).then(() => {
					this.excelData = this.signInData //你要导出的数据list
					//console.log(this.excelData)
					//this.export2Excel()
					this.export2ExcelStyle()
				}).catch(() => {
					console.log('cancel'); //取消
				});
			},
			//出勤表导出：必选幼儿园 + 年级 + 班级 +日期 
			export2Excel() {
				require.ensure([], () => {
					const {
						export_json_to_excel
					} = require('../../vendor/Export2Excel'); //这里必须使用绝对路径

					//const tHeader = ['序号', '姓名', '1', '2', '3', '出勤', '缺勤', '备注'];
					//const filterVal = ['ZADMSID', 'HABNAME', 'ZADA1', 'ZADA2', 'ZADA3', 'ATTECOUNT', 'DUTYCOUNT', 'ZADBEIZU']; 

					// 导出的表头名
					var title = [];
					title.push("序号");
					title.push("姓名");
					for (let i in this.excelTitle.split(',')) {
						title.push(this.excelTitle.split(',')[i]);
					}
					title.push("出勤");
					title.push("缺勤");
					title.push("备注");
					const tHeader = title


					//导出的表头字段名
					var columns = [];
					columns.push("ROWNUM");
					columns.push("HABNM");
					for (let i in this.excelColumns.split(',')) {
						columns.push(this.excelColumns.split(',')[i]);
					}
					columns.push("ZADIN");
					columns.push("ZADOUT");
					columns.push("NOTE");
					const filterVal = columns

					//console.log(tHeader);
					//console.log(filterVal);

					const list = this.excelData;
					const data = this.formatJson(filterVal, list);
					//export_json_to_excel(tHeader, data, '北斗幼儿园 + 年级 + 班级(2020-09-15至2020-10-13)出勤表'); // 导出的表格名称，根据需要自己命名
					export_json_to_excel(tHeader, data, '出勤表打印测试'); // 导出的表格名称，根据需要自己命名


				})
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => v[j]))
			},
			export2ExcelStyle() {
				//npm install --save xlsx-style
				//https://www.cnblogs.com/yinxingen/p/11052184.html
				import('@/vendor/Export2ExcelStyle').then(excel => {
					
					// 导出的表头名
					var head = [];
					head.push("序号");
					head.push("姓名");
					for (let i in this.excelTitle.split(',')) {
						head.push(this.excelTitle.split(',')[i]);
					}
					head.push("出勤");
					head.push("缺勤");
					head.push("备注");
					const tHeader = head


					//导出的表头字段名
					var columns = [];
					columns.push("ROWNUM");
					columns.push("HABNM");
					for (let i in this.excelColumns.split(',')) {
						columns.push(this.excelColumns.split(',')[i]);
					}
					columns.push("ZADIN");
					columns.push("ZADOUT");
					columns.push("NOTE");
					const filterVal = columns

					const list = this.excelData
					const data = this.formatJson(filterVal, list)
					data.map(item => {
						item.map((i, index) => {
							if (!i) {
								item[index] = ''
							}
						})
					})

					//console.log(data)

					//班级名 出勤表 (2020年11月1日~XXXX)
					let dt_start = new Date(this.query.start)
					let dt_end = new Date(this.query.end)
					//console.log(sSTARTDATE.getFullYear())
					let sSTARTDATE = dt_start.getFullYear() + '年' + (dt_start.getMonth() + 1) + '月' + dt_start.getDate() + '日';
					let sENDDATE = dt_end.getFullYear() + '年' + (dt_end.getMonth() + 1) + '月' + dt_end.getDate() + '日';
					
					var title = this.query.hadSABNAME + ' 出勤表 (' + sSTARTDATE + '~' + sENDDATE + ')';
					
					excel.export_json_to_excel({
						titleName: title,
						header: tHeader,
						data,
						border: true,
						filename: this.query.hadSABNAME, //班级名
						autoWidth: true,
						bookType: 'xlsx'
					})
				})
			}
		}
	};
</script>
<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 12%;
	}


	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.black {
		color: #000000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.select-shop {
		width: 16%;
	}

	.select-agent {
		width: 14%;
	}

	.el-row {
		margin-top: 15px;
	}

	.bg-purple {
		text-align: left;
	}

	.bg-purple-light {
		text-align: right;
	}

	.grid-content {
		min-height: 34px;
	}

	.handle-input {
		width: 220px;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
	}

	.el-upload--text {
		width: 140px;
		height: 80px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 140px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}

	.avatar {
		width: 140px;
		height: 80px;
		display: block;
	}

	.el-dialog__footer {
		text-align: center;
	}

	.dialog-footer-btn {
		margin-right: 20px;
	}

	.cropper {
		width: auto;
		height: 300px;
	}
</style>
